import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = ({ currentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Home', id: 'home' },
    { name: 'Features', id: 'features' },
    { name: 'About', id: 'about' },
    { name: 'Contact', id: 'contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-content">
          <a href="#/home" className="nav-logo">
            <div className="logo-icon">T</div>
            <span className="logo-text">HZD-ERP</span>
          </a>

          <div className="nav-desktop">
            {navigation.map((item) => (
              <a
                key={item.id}
                href={`#/${item.id}`}
                className={`nav-link ${currentPage === item.id ? 'nav-link-active' : ''}`}
              >
                {item.name}
              </a>
            ))}
            <a href="#/contact" className="btn btn-nav">
              Get Started
            </a>
          </div>

          <button className="nav-mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="nav-mobile">
            {navigation.map((item) => (
              <a
                key={item.id}
                href={`#/${item.id}`}
                onClick={() => setMobileMenuOpen(false)}
                className={`nav-mobile-link ${currentPage === item.id ? 'nav-mobile-link-active' : ''}`}
              >
                {item.name}
              </a>
            ))}
            <a 
              href="#/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="btn btn-primary btn-full"
            >
              Get Started
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
